module.exports = __webpack_public_path__ + "static/media/welcome-icon.efe9d4ea.svg";